import React, { useState } from "react";
import "./CDC.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import { ugColleges } from "../../data/ugcolleges";
import { pgColleges } from "../../data/pgcolleges";
import { professionalColleges } from "../../data/professionalColleges";
import { cdcStaff } from "../../data/cdcStaff";
import { programmesByCategory } from "../../data/programsoffered";

const CDC = () => {
  const [activeTab, setActiveTab] = useState("about");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <Navbar />

      <section className="cdc-page">
        <div className="cdc-container">
          <h1 className="cdc-title">College Development Cell</h1>
          <p className="cdc-subtitle">
            Affiliation & Institutional Development
          </p>

          {/* Mobile Toggle */}
          <button
            className="cdc-mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            ☰ CDC Navigation
          </button>

          <div className="cdc-layout">
            {/* ===== Sidebar ===== */}
            <aside className={`cdc-sidebar ${mobileOpen ? "open" : ""}`}>
              <div className="cdc-sidebar-header">
                <h3>Quick Links</h3>
              </div>

              <nav className="cdc-sidebar-nav">
                {[
                  ["about", "About CDC"],
                  ["objectives", "Objectives"],
                  ["functions", "Functions"],
                  ["ug", "UG Colleges"],
                  ["pg", "PG Colleges"],
                  ["professional", "Professional Colleges"],
                  ["programmes", "Programmes"],
                  ["contact", "Staff"]
                ].map(([key, label]) => (
                  <button
                    key={key}
                    className={`cdc-nav-item ${activeTab === key ? "cdc-nav-item-active" : ""
                      }`}
                    onClick={() => {
                      setActiveTab(key);
                      setMobileOpen(false);
                    }}
                  >
                    {label}
                  </button>
                ))}
              </nav>
            </aside>

            {/* ===== Content ===== */}
            <main className="cdc-content">

              {activeTab === "about" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}> College Development Cell</h2>

                  <div className="cdc-officials">
                    <div className="cdc-official-card">
                      <img src="/mathematics/putcha1.jpg" alt="Dean CDC" />
                      <h4>Prof. Venkata Sundaranand Putcha</h4>
                      <p className="designation">
                        Dean, College Development Council
                      </p>
                      <p>Rayalaseema University, Kurnool</p>
                      <p>Email: deancdcru@gmail.com</p>
                      <p>Phone: 9848226855</p>
                    </div>

                    <div className="cdc-official-card">
                      <img src="/commerce/moses.JPG" alt="CDC Coordinator" />
                      <h4>Dr. N. Moses</h4>
                      <p className="designation">CDC Coordinator</p>
                      <p>Rayalaseema University, Kurnool</p>
                      <p>Email: drmosesknl@gmail.com</p>
                      <p>Phone: 9885499307</p>
                    </div>
                  </div>

                  <p>
                    The College Development Cell (CDC) of Rayalaseema University
                    ensures academic quality, institutional development and
                    effective governance of affiliated colleges.
                  </p>
                </>
              )}

              {activeTab === "objectives" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>Objectives</h2>
                  <ul>
                    <li>Ensure academic quality</li>
                    <li>Support NAAC & NIRF</li>
                    <li>Strengthen governance</li>
                    <li>Promote institutional growth</li>
                  </ul>
                </>
              )}

              {activeTab === "functions" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>Functions</h2>
                  <ul>
                    <li>Grant affiliation</li>
                    <li>Conduct inspections</li>
                    <li>Monitor statutory compliance</li>
                    <li>Coordinate academic reforms</li>
                  </ul>
                </>
              )}

              {activeTab === "ug" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>UG Colleges</h2>
                  <div className="cdc-table-wrapper">
                    <table className="cdc-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Place</th>
                          <th>District</th>
                          <th>Phone</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ugColleges.map((c) => (
                          <tr key={c.sno}>
                            <td>{c.sno}</td>
                            <td>{c.name}</td>
                            <td>{c.place}</td>
                            <td>{c.district}</td>
                            <td>{c.phone}</td>
                            <td>{c.email}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}



              {activeTab === "pg" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>Affiliated PG Colleges</h2>
                  <p>Postgraduate colleges offering PG programmes under the University.</p>

                  <div className="cdc-table-wrapper">
                    <table className="cdc-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>JNB ID</th>
                          <th>Name of College</th>
                          <th>Place</th>
                          <th>District</th>
                          <th>Phone</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pgColleges.map(college => (
                          <tr key={college.sno}>
                            <td>{college.sno}</td>
                            <td>{college.jnbId}</td>
                            <td>{college.name}</td>
                            <td>{college.place}</td>
                            <td>{college.district}</td>
                            <td>{college.phone}</td>
                            <td>
                              <a href={`mailto:${college.email}`}>
                                {college.email}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {activeTab === "professional" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>Professional Colleges</h2>

                  <div className="cdc-table-wrapper">
                    <table className="cdc-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>JNB ID</th>
                          <th>Name of College</th>
                          <th>Place</th>
                          <th>District</th>
                          <th>Phone</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {professionalColleges.map(college => (
                          <tr key={college.id}>
                            <td>{college.id}</td>
                            <td>{college.jnbId}</td>
                            <td>{college.name}</td>
                            <td>{college.place}</td>
                            <td>{college.district}</td>
                            <td>{college.phone}</td>
                            <td>
                              <a href={`mailto:${college.email}`}>
                                {college.email}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {/* ===== PROGRAMMES ===== */}
              {activeTab === "programmes" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>Programmes Offered</h2>
                  <p>List of programmes offered by affiliated colleges of Rayalaseema University.</p>

                  <h3>Undergraduate Programmes</h3>
                  <ul>
                    {programmesByCategory.undergraduate.map((prog, index) => (
                      <li key={index}>{prog}</li>
                    ))}
                  </ul>

                  <h3>Postgraduate Programmes</h3>
                  <ul>
                    {programmesByCategory.postgraduate.map((prog, index) => (
                      <li key={index}>{prog}</li>
                    ))}
                  </ul>

                  <h3>Professional & Technical Programmes</h3>
                  <ul>
                    {programmesByCategory.professional.map((prog, index) => (
                      <li key={index}>{prog}</li>
                    ))}
                  </ul>

                  <h3>Research Programmes</h3>
                  <ul>
                    {programmesByCategory.research.map((prog, index) => (
                      <li key={index}>{prog}</li>
                    ))}
                  </ul>
                </>
              )}


              {activeTab === "contact" && (
                <>
                  <h2 style={{ color: '#0B3C5D', textAlign: 'center' }}>CDC Staff</h2>
                  <div className="cdc-table-wrapper">
                    <table className="cdc-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Designation</th>
                          <th>Mobile</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cdcStaff.map((s) => (
                          <tr key={s.id}>
                            <td>{s.id}</td>
                            <td>{s.name}</td>
                            <td>{s.designation}</td>
                            <td>{s.phone}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

            </main>
          </div>
        </div >
      </section >

      <Footer />
    </>
  );
};

export default CDC;
